import styled from 'styled-components';

const TopMenuIcon = styled.div`
  && {
    margin-left: 14px;
  }
`;
export default TopMenuIcon;
